import { HttpHeaders, HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GetBaseUrl } from "../../helper/getBaseUrl";
import { environment } from "environments/environment";

const httpOptions = {
    headers: new HttpHeaders({ "Content-Type": "application/json" }),
};

@Injectable()
export class ApiTicketServiceService {
    private baseUrl = GetBaseUrl.baseUrl();

    constructor(private http: HttpClient) {}

    public getAll(id_tenant: number): Observable<any> {
        return this.http.get(
            this.baseUrl +
                "/ticket-service?platform=" +
                environment.platform +
                "&id_tenant=" +
                id_tenant
        );
    }
}
